import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import axios from "axios";
import performance from "../../../../../assets/performance.png";
import { Dropdown } from "primereact/dropdown";
import appUrl from "../../../../config/appUrl";

const BRAND = "#4475a5";
const BRAND_FILL = "rgba(68, 117, 165, 0.12)";

const VehicleTypeChart = () => {
  const [isMonthly, setIsMonthly] = useState(true);
  const [chartData, setChartData] = useState(null);
  const storedLoginRes = JSON.parse(localStorage.getItem("loginRes"));
  const userSite = storedLoginRes?.site?._id || "";

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${appUrl.BASE_URL}ParkingHistory/getVehicleTypeSummary`,
        {
          params: {
            site: userSite,
            booth: "",
            vehicleType: "",
            isMonthly: isMonthly,
            GTagDataOnly: false,
            QRDataOnly: false,
          },
        },
      );

      const apiData = res.data.data || [];

      let labels = [];
      let values = [];

      if (isMonthly) {
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        labels = apiData.map((d) => monthNames[d.month]);
        values = apiData.map((d) => d.totFee);
      } else {
        labels = apiData.map((d) => ` ${d.day}`);
        values = apiData.map((d) => d.totFee);
      }

      setChartData({
        labels: labels,
        datasets: [
          {
            label: "Revenue",
            data: values,
            borderColor: BRAND,
            backgroundColor: BRAND_FILL,
            tension: 0.35,
            pointBackgroundColor: BRAND,
            pointBorderColor: "#fff",
            pointRadius: 3,
            pointHoverRadius: 5,
            fill: true,
          },
        ],
      });
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [isMonthly]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function (context) {
            const val = context.parsed.y;
            return val ? val.toLocaleString() : "0";
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value.toLocaleString();
          },
        },
        grid: { color: "#eef2f6" },
      },
      x: { grid: { display: false } },
    },
  };

  return (
    
    <div className="dashboard-chart-inner">
      <div className="dashboard-chart-head">
        <h5>Vehicle Type Report</h5>
        <select
          className="dashboard-chart-select"
          value={isMonthly ? "monthly" : "daily"}
          onChange={(e) => setIsMonthly(e.target.value === "monthly")}
          aria-label="Report period"
        >
          <option value="monthly">Yearly</option>
          <option value="daily">Last Month</option>
        </select>
      </div>
      <div className="dashboard-chart-canvas">
        {chartData ? (
          <Chart
            type="line"
            style={{ height: "300px" }}
            data={chartData}
            options={options}
          />
        ) : (
          <p className="text-600 m-0">Loading…</p>
        )}
      </div>
      </div>
  );
};

export default VehicleTypeChart;
